import React, { useEffect, useRef } from 'react';
import { Modal } from 'react-bootstrap';
import { AiOutlineClose } from 'react-icons/ai';import Hls from 'hls.js';

const VideoPlayModal = ({ modalShow, modalHide, video, children, lecturetitle }) => {
  const videoRef = useRef(null);

  useEffect(() => {
    if (!video) return;
    const videoEl = videoRef.current;

    // Handle m3u8 live stream using hls.js
    if (video.endsWith('.m3u8') && Hls.isSupported()) {
      const hls = new Hls();
      hls.loadSource(video);
      hls.attachMedia(videoEl);
      return () => {
        hls.destroy();
      };
    }
    // For Safari (which supports HLS natively)
    else if (videoEl.canPlayType('application/vnd.apple.mpegurl')) {
      videoEl.src = video;
    }
    else {
      // Normal mp4
      videoEl.src = video;
    }
  }, [video]);

  return (
    <Modal
      show={modalShow}
      onHide={modalHide}
      backdrop="static"
      keyboard={false}
      centered
      size="lg"
      style={{
        borderRadius: '12px',
        boxShadow: '0 8px 20px rgba(0,0,0,0.3)',
        overflow: 'hidden', // ensures border radius applies
      }}
    >
      {/* Custom header */}
      <div
        style={{
          display: 'flex',
          justifyContent: 'space-between', // title left, close icon right
          alignItems: 'center',
          padding: '10px 20px',
          backgroundColor: '#0d6efd',
          borderTopLeftRadius:"6px",
          borderTopRightRadius:"6px",
        }}
      >
        <h3 style={{ color: 'white', margin: 0 }}>{lecturetitle}</h3>
        <AiOutlineClose
          onClick={modalHide}
          style={{
            fontSize: '24px',
            color: 'white',
            cursor: 'pointer',
          }}
        />
      </div>
      <Modal.Body>

        {children ? (
          children
        ) : (
          <video
            ref={videoRef}
            width="100%"
            height="400px"
            controls
            autoPlay
            style={{ backgroundColor: 'black' }}
            className='recorded-video'
          >
            Your browser does not support HTML5 video.
          </video>
        )}
      </Modal.Body>
    </Modal>
  );
};

export default VideoPlayModal;
